module.exports = __webpack_public_path__ + "img/login.e97f7ff7.svg";